<style src="./CreateCampaign.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <form @submit.prevent="sendCampaign">
      <div class="form-group">
        <label>Titulo da campanha</label>
        <input
          type="text"
          class="form-control"
          v-model="form.title"
          placeholder="Minha campanha"
        />
      </div>
      <div class="form-group">
        <label>Url do banner</label>
        <input
          type="text"
          class="form-control"
          v-model="form.bannerUrl"
          placeholder="https://google.com"
        />
      </div>
      <div class="form-group">
        <label>Validade da campanha</label>
        <input
          type="date"
          class="form-control"
          v-model="form.validity"
          placeholder="Validade da campanha"
        />
      </div>

      <vue-dropzone
        ref="imgDropZone"
        class="customdropzone"
        id="customdropzone"
        @vdropzone-max-files-exceeded="maxfilesexceeded"
        :options="dropzoneOptions"
      ></vue-dropzone>

      <div class="input-group-btn">
        <button
          type="button"
          class="btn btn-lg btn-primary "
          @click="sendCampaign"
        >
          <i class="fa fa-plus"></i>
          Criar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "CreateCampaign",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data: () => ({
    form: {
      title: "",
      bannerUrl: "",
      validity: "",
    },
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 250,
      // thumbnailHeight: 300,
      maxFilesize: 0.5,
      maxFiles: 1,
      dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Upload",
    },
  }),
  computed: {},
  methods: {
    maxfilesexceeded(file) {
      const dropZoneRef = this.$refs.imgDropZone;
      dropZoneRef.removeAllFiles();
      dropZoneRef.addFile(file);
    },
    async sendCampaign() {
      const { title, bannerUrl, validity } = this.form;
      if (title.trim().length === 0 || bannerUrl.trim().length === 0) {
        return;
      }
      const dropZoneRef = this.$refs.imgDropZone;
      const file = dropZoneRef.getAcceptedFiles();
      if (file.length === 0) {
        return;
      }
      const image = {
        base64: file[0].dataURL,
        fileName: file[0].name,
      };
      try {
        await this.$store.dispatch("CAMPAIGN/CreateCampaign", {
          title,
          bannerUrl,
          validity,
          image,
        });
        this.$toasted.success("Campanha criada.");
      } catch (error) {
        this.$toasted.error("Não foi possível criar campanha");
      }
    },
  },
};
</script>
